import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';

import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { AddDataConnectClusterDialogBody, AddDataConnectClusterDialogProps, AddDataConnectClusterDialogState } from '~src/settings/dataconnect-settings/sections/dataConnectMultiCluster/AddDataConnectClusterDialog';
import { ICreateBaasClusterResult } from '~src/settings/dataconnect-settings/serverApi/requests/CreateBaasClusterRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';
import { cssClass } from '~src/style';

import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';


const addClusterButtonClass = cssClass('add-cluster', 'root', {
  display: 'block',
  marginBottom: TabStyles.Spacing.DefaultSpace
});

const addClusterIconClass = cssClass('add-cluster', 'icon', {
  verticalAlign: 'middle'
});

export type AddNewClusterButtonProps = Readonly<{
  existingClusterNames: ReadonlyArray<string>;
  allowCreateCluster: boolean;
  refreshEdgePoolsAndClusters: () => void;
  hasLoadedEdgePoolsAndClusters: boolean;
}>;

export function AddNewClusterButton(props: AddNewClusterButtonProps) {
  return (
    <ButtonWidget
      title={Messages.dataConnectSiteSettingsAddCluster()}
      buttonType={ButtonType.Outline}
      testId={'add-new-cluster-button'}
      onClick={() => openAddNewClusterDialog(props.existingClusterNames, props.refreshEdgePoolsAndClusters)}
      className={addClusterButtonClass}
      disabled={!props.hasLoadedEdgePoolsAndClusters || !props.allowCreateCluster}
    >
      <img src={imgPath('plus_14px-small.svg')} alt={''} className={addClusterIconClass} />
      <span> {Messages.dataConnectSiteSettingsAddCluster()} </span>
    </ButtonWidget>
  );
}

function openAddNewClusterDialog(existingClusterNames: ReadonlyArray<string>, refreshEdgePools: () => void) {
  const action = (_: AddDataConnectClusterDialogProps, state: AddDataConnectClusterDialogState) => {
   return  BaasEdgePoolAndCluster.createBaasCluster({ displayName: state.clusterName})
      .then((result: ICreateBaasClusterResult) => {
        refreshEdgePools();
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
        if (result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsAddClusterSuccess({ CLUSTER_NAME: state.clusterName }) });
        }
        return Promise.resolve();
      });
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsAddCluster(),
    bodyComponent: AddDataConnectClusterDialogBody,
    initialBodyProps: { existingClusterNames },
    initialDialogState: { clusterName: '', hasError: false },
    actionName: Messages.dataConnectSiteSettingsAddClusterButton(),
    action: action,
    actionDisabled: (_, state: AddDataConnectClusterDialogState) => state.clusterName.length === 0 || state.hasError,
    dismissDialogOnActionFailed: false,
    dialogWidth: TabDialogWidth.width375px,
  });

  return Promise.resolve(dialogInstance.result);
}
